(ns teamoesterreich.admin-mode.lebensretter.detail.zip-sms-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h]
            ))

(defn valid-zip? [value]
  (and (string? value)
       (some? (re-find #"^\d{4}$" value))))

(defn valid-zip-list? [value]
  (and (string? value)
       (or (empty? value)
           (every? valid-zip? (map clojure.string/trim (clojure.string/split value #","))))))

(defn make-valid-zip-list [value]
  (clojure.string/join ", " (set (filter valid-zip? (map clojure.string/trim (clojure.string/split value #","))))))

(defn form [!postalCodesAlways !postalCodesNever !smsFallback
            storedAlways storedNever smsFallbackActive]
  (let [alwaysError (not (valid-zip-list? @!postalCodesAlways))
        neverError (not (valid-zip-list? @!postalCodesNever))]
    [mui/box {:sx {:display "flex" :flex-wrap "wrap" :column-gap "1rem" :row-gap "0.2rem"}}
     [:h3 {:style {:flex-grow "1" :flex-basis "100%"}} "PLZ-Alarmierung"]
     [mui/text-field {
                      :style      {:background-color (if (not= storedAlways @!postalCodesAlways) "#ffd6d2" "#ffffff")}
                      :onChange   (fn [e] (reset! !postalCodesAlways (h/event-value e)))
                      :label      "Immer alarmieren"
                      :value      (or @!postalCodesAlways "")
                      :helperText (if alwaysError "UNGÜLTIG!!" "Komma-getrennte Liste von PLZ")
                      :error      alwaysError
                      }]
     [mui/text-field {
                      :style      {:background-color (if (not= storedNever @!postalCodesNever) "#ffd6d2" "#ffffff")}
                      :onChange   (fn [e] (reset! !postalCodesNever (h/event-value e)))
                      :label      "Niemals alarmieren"
                      :value      (or @!postalCodesNever "")
                      :helperText (if neverError "UNGÜLTIG!!" "Komma-getrennte Liste von PLZ")
                      :error      neverError
                      }]
     [mui/form-control-label
      {
       :style   {:background-color (if (not= smsFallbackActive @!smsFallback) "#ffd6d2" "transparent")}
       :label   "SMS-Fallback"
       :control (r/as-element
                  [mui/checkbox {:color    "primary"
                                 :checked  (or @!smsFallback false)
                                 :onChange (fn [_ val]
                                             (reset! !smsFallback val))
                                 }])
       }
      ]
     ]

    ))

